import React, {FC, useState} from 'react';
import './LeadSimulations.scss';
import {Card} from "react-bootstrap";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import {LeadAllModel} from "../../../models/Leads/LeadsAll/LeadAllModel";
import SkeletonTable from "../../SkeletonTable/SkeletonTable";
import FormataMoeda from "../../../utils/FormataMoeda";
import ModalLeadsInfoSimulationProposal from "../ModalLeadsInfoSimulationProposal/ModalLeadsInfoSimulationProposal";
import moment from "moment";
import {OrigemIcon} from "../../../utils/OrigemIcon";
import getProductImage from '../../../utils/getProductImage';

interface LeadSimulationsProps {
    isLoading?: boolean;
    userSimulations?: LeadAllModel[];
}

const LeadSimulations: FC<LeadSimulationsProps> = ({isLoading, userSimulations = []}) => {
    const [showDetails, setShowDetails] = useState<boolean>(false);
    const [itemDetail, setItemDetail] = useState<LeadAllModel>({});

    const handleDetails = (item: LeadAllModel) => {
        setItemDetail(item);
        setShowDetails(true);
    }

    const renderList = () => {
        return (
            <>
                {userSimulations?.length > 0 ? (
                    userSimulations?.map((x: LeadAllModel) => (
                        <OverlayTrigger key={x.id}
                                        placement={'top'}
                                        overlay={
                                            <Tooltip>
                                                Ver detalhes
                                            </Tooltip>
                                        }
                        >
                            <tr onClick={() => handleDetails(x)}>
                                <td><i className={`${OrigemIcon(x.appOrigem || '')}`}/></td>
                                <td>{x._produto}</td>
                                <td>
                                    <img {...getProductImage(x._financeira)} alt={getProductImage(x._financeira).alt} />
                                </td>
                                <td>{FormataMoeda(x.valorPrincipal)}</td>
                                <td>{moment(x.created_at).format('DD/MM/YYYY HH:mm:ss')}</td>
                                <td>{x.digitador}</td>
                            </tr>
                        </OverlayTrigger>
                    ))
                ) : (
                    <tr className='text-center'>
                        <td colSpan={5} style={{cursor: 'default'}}>Não existem Simulações para listar.</td>
                    </tr>
                )}
            </>
        )
    }
    return (

        <Card className="LeadSimulations" data-testid="LeadSimulations">
            <Card.Header>
                <Card.Title>SIMULAÇÕES DO LEAD</Card.Title>
            </Card.Header>
            <Card.Body className='history-cards'>
                {!isLoading ? (
                    <div className="table-responsive">
                        <table className="table text-sm m-0">
                            <thead className="thead-light">
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">PRODUTO</th>
                                <th scope="col">FINANCEIRA</th>
                                <th scope="col">VALOR</th>
                                <th scope="col">DATA</th>
                                <th scope="col">DIGITADOR</th>
                            </tr>
                            </thead>
                            <tbody>
                            {renderList()}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <SkeletonTable/>
                )}
            </Card.Body>
            <ModalLeadsInfoSimulationProposal
                show={showDetails}
                onClose={() => setShowDetails(false)}
                lead={itemDetail}
            />
        </Card>


    )
};

export default LeadSimulations;
